import { CarPreloadingStrategy } from './shared/car-preloading-strategy';
import { ErrorPageComponent } from './error-page/error-page.component';
import { LinktoComponent } from './linkto/linkto.component';
import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';

const routes: Routes = [
  {
    path: 'cancellation',
    loadChildren: () => import('./cancellation/cancellation.module').then(m => m.CancellationModule)
  },
  {
    path: 'confirmation',
    loadChildren: () => import('./confirmation/confirmation.module').then(m => m.ConfirmationModule)
  },
  {
    path: 'fare-rules',
    loadChildren: () => import('./fare-rules/fare-rules.module').then(m => m.FareRulesModule)
  },
  {
    path: 'payment-method',
    loadChildren: () => import('./payment-method/payment-method.module').then(m => m.PaymentMethodModule)
  },
  {
    path: 'reservation',
    loadChildren: () => import('./reservation/reservation.module').then(m => m.ReservationModule)
  },
  {
    path: 'review',
    loadChildren: () => import('./review/review.module').then(m => m.ReviewModule)
  },
  {
    path: 'cars',
    loadChildren: () => import('./search-result/search-result.module').then(m => m.SearchResultModule)
  },
  {
    path: 'star-card-registration',
    loadChildren: () => import('./star-card-registration/star-card-registration.module').then(m => m.StarCardRegistrationModule)
  },
  {
    path: '',
    loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule)
  },
  // Non-lazy-loaded components
  { path: 'linkto', component: LinktoComponent },
  { path: 'error/:reason', component: ErrorPageComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {preloadingStrategy: CarPreloadingStrategy}) ],
  exports: [ RouterModule ],
  providers: [ CarPreloadingStrategy ]
})

export class CarRoutingModule {}
